<template>
  <div id="leftSideBar">
    <p hidden>
      <span class="getCurrent">{{ current }}</span>
      <span class="leftIndex">{{ leftIndex }}</span>
    </p>
    <ul></ul>
  </div>
</template>

<script>
import $ from "jquery";
// import cookies from "vue-cookies";
export default {
  data() {
    return {
      data: [],
      dept: [
        {
          name: "机构管理",
          link: "/dept",
        },
      ],
      dataBase: [
        {
          name: "资源库分类管理",
          link: "/sortManage",
        },
        {
          name: "资源库管理",
          link: "/dataBseManage",
        },
        {
          name: "来源管理",
          link: "/sourceManage",
        },
        {
          name: "数据类别管理",
          link: "/dbSortManage",
        },
      ],
      system: [
        {
          name: "用户管理",
          link: "/user",
        },
        {
          name: "角色管理",
          link: "/role",
        },
        {
          name: "权限管理",
          link: "/authority",
        },
      ],
      toStorage: [
        {
          name: "资源入库",
          link: "/sourceToStorage",
        },
        {
          name: "多媒体资源入库",
          link: "/mediaToStorage",
        },
        {
          name: "3D资源入库",
          link: "/3DToStorage",
        },
      ],
      dbWork: [
        // {
        //   name: "百科全书资源管理",
        //   link: "/bkManage",
        // },
        // {
        //   name: "辞典工具资源管理",
        //   link: "/dicToolManage",
        // },
        // {
        //   name: "专项数据资源管理",
        //   link: "/speciaDBManage",
        // },
        // {
        //   name: "多媒体资源管理",
        //   link: "/mediaManage",
        // },
        // {
        //   name: "多媒体集资源管理",
        //   link: "/mediaSet",
        // },
        // {
        //   name: "编委库管理",
        //   link: "/editBoardManage",
        // },
        // {
        //   name: "作者库管理",
        //   link: "/mediaSet",
        // },
        // {
        //   name: "大事记管理",
        //   link: "/bigEvent",
        // },
        // {
        //   name: "资源查重",
        //   link: "/repeatCheck",
        // },
        // {
        //   name: "出库任务管理",
        //   link: "/outdbManage",
        // },
      ],
      labelManage: [
        // {
        //   name: "标签库管理",
        //   link: "taglibManage",
        // },
        // {
        //   name: "标引库管理",
        //   link: "indexlibManage",
        // },
      ],
    };
  },
  props: {
    current: String,
    leftIndex: String,
  },
  mounted() {
    var getCurrent = $(".getCurrent").text();
    var leftMenu = JSON.parse(localStorage.getItem("catalog"));
    this.data = leftMenu.find((item) => item.permName == getCurrent).children;
    var leftIndex = $(".leftIndex").text();
    // switch (getCurrent) {
    //   case "dept":
    //     this.data = this.dept;
    //     break;
    //   case "dataBase":
    //     this.data = this.dataBase;
    //     break;
    //   case "system":
    //     this.data = this.system;
    //     break;
    //   case "toStorage":
    //     this.data = this.toStorage;
    //     break;
    //   case "dbWork":
    //     this.data = this.dbWork;
    //     break;
    //   case "labelManage":
    //     this.data = this.labelManage;
    //     break;
    // }
    var listHtml = "";
    for (let i = 0; i < this.data.length; i++) {
      listHtml +=
        '<li class="sidebar-title ' +
        this.data[i].permName +
        '"> <a href="' +
        this.data[i].permName +
        '">' +
        this.data[i].permDesc +
        "</a></li>";
    }
    $("#leftSideBar ul").html(listHtml);
    setTimeout(function () {
      $.each($("#leftSideBar ul li"), function (index, obj) {
        var divClass = $(obj).prop("class").split(" ")[1];
        console.log(index);
        if (divClass == leftIndex) {
          $(obj).addClass("active");
          $(obj).siblings().removeClass("active");
        }
      });
    }, 300);
  },
};
</script>

<style>
</style>